import { render, staticRenderFns } from "./bookinglist.vue?vue&type=template&id=146e85f1&scoped=true"
import script from "./bookinglist.vue?vue&type=script&lang=js"
export * from "./bookinglist.vue?vue&type=script&lang=js"
import style0 from "./bookinglist.vue?vue&type=style&index=0&id=146e85f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146e85f1",
  null
  
)

export default component.exports